export enum ChatUIMessageType {
	AI = 'ai',
	USER = 'user',
	LOADING = 'loading',
}
